import { render, staticRenderFns } from "./LiveView.vue?vue&type=template&id=fc1dec7c&scoped=true&"
import script from "./LiveView.vue?vue&type=script&lang=js&"
export * from "./LiveView.vue?vue&type=script&lang=js&"
import style0 from "./LiveView.vue?vue&type=style&index=0&id=fc1dec7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1dec7c",
  null
  
)

export default component.exports